/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * GENERAL LAYOUT FUNCTIONALITY
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

import { viewportDimensions } from '/helpers/window'

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE CLASSES
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $html = document.querySelector('html')
function resizeClassChanger() {
	$html.classList.remove('resp-sm')
	$html.classList.remove('resp-md')
	$html.classList.remove('resp-lg')
	if (viewportDimensions().width < _MEDIA_SMALL) {
		$html.classList.add('resp-sm')
	} else if (viewportDimensions().width < _MEDIA_MEDIUM) {
		$html.classList.add('resp-md')
	} else {
		$html.classList.add('resp-lg')
	}
}
resizeClassChanger()
window.addEventListener('resize', _.debounce(resizeClassChanger, 150))

let transitionTimer
window.addEventListener('resize', () => {
	$html.classList.add('no-transitions')
	transitionTimer = setTimeout(() => {
		clearTimeout(transitionTimer)
		$html.classList.remove('no-transitions')
	}, 1500)
})

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * STICKY HEADER JAVASCRIPT
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

let lastScrollTop = 0
const delta = 5
const $header = document.querySelector('.header')
let headerHeight = $header.clientHeight

window.addEventListener('scroll', _.throttle(() => {
	const scrollTop = window.pageYOffset
	// make sure they scroll more than delta
	if (Math.abs(lastScrollTop - scrollTop) <= delta + headerHeight) { return }
	if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
		const $openMenu = document.querySelector('.menus .menu > [aria-expanded="true"]')
		// only hide the menu if something is not open
		if (!$openMenu) {
			$html.classList.add('header-up') // scroll down
		}
	} else {
		$html.classList.remove('header-up') // scroll up
	}
	lastScrollTop = scrollTop
}, 100))
window.addEventListener('resize', () => headerHeight = $header.clientHeight)

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE UTILITY LINKS JAVASCRIPT
 * Moves the DOM around at large size
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $menus = $header.querySelector('.menus')
const $topNav = $header.querySelector('nav.top')
const $links = document.querySelector('.utility-links')
function responsiveUtilityLinks() {
	const isLargeView = viewportDimensions().width >= _MEDIA_MEDIUM
	const $nextElement = isLargeView ? $topNav.nextElementSibling : $menus.nextElementSibling
	if ($nextElement === $links) {
		if (isLargeView) { // move it up
			$menus.insertAdjacentElement('afterend', $links)
		} else { // move it back
			$topNav.insertAdjacentElement('afterend', $links)
		}
	}
}
responsiveUtilityLinks()
window.addEventListener('resize', () => responsiveUtilityLinks())

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE HEADER JAVASCRIPT
 * main navigation toggles on `click` medium and small, but not large
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $mainMenuIcon = document.querySelector('.header .main-menu > .icon')
const $mainMenuDropdown = document.querySelector('.header .dropdown-menu')
function responsiveHeaderDropdown() {
	if (viewportDimensions().width >= _MEDIA_MEDIUM) {
		const haspopup = $mainMenuIcon.getAttribute('aria-haspopup')
		const expanded = $mainMenuIcon.getAttribute('aria-expanded')
		const hidden = $mainMenuDropdown.getAttribute('aria-hidden')
		if (haspopup && expanded && hidden) {
			$mainMenuIcon.setAttribute('temp-haspopup', haspopup)
			$mainMenuIcon.setAttribute('temp-expanded', expanded)
			$mainMenuDropdown.setAttribute('temp-hidden', hidden)
		}
		$mainMenuIcon.removeAttribute('aria-haspopup')
		$mainMenuIcon.removeAttribute('aria-expanded')
		$mainMenuDropdown.removeAttribute('aria-hidden')
		$mainMenuDropdown.classList.remove('visibility-hidden')
	} else if ($mainMenuDropdown.classList.contains('visibility-hidden')) {
		const haspopup = $mainMenuIcon.getAttribute('temp-haspopup')
		const expanded = $mainMenuIcon.getAttribute('temp-expanded')
		const hidden = $mainMenuDropdown.getAttribute('temp-hidden')
		if (haspopup && expanded && hidden) {
			$mainMenuIcon.setAttribute('aria-haspopup', haspopup)
			$mainMenuIcon.setAttribute('aria-expanded', expanded)
			$mainMenuDropdown.setAttribute('aria-hidden', hidden)
		}
		$mainMenuIcon.removeAttribute('temp-haspopup')
		$mainMenuIcon.removeAttribute('temp-expanded')
		$mainMenuDropdown.removeAttribute('temp-hidden')
		$mainMenuDropdown.classList.add('visibility-hidden')
	}
}
responsiveHeaderDropdown()
window.addEventListener('resize', () => {
	responsiveHeaderDropdown()
})

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE HEADER JAVASCRIPT
 * plus/minus main navigation on medium and small
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $$mainMenuToggles = document.querySelectorAll('.dropdown-menu .toggle')
_.each($$mainMenuToggles, $toggle => {
	$toggle.addEventListener('click', function() {
		const $section = $toggle.closest('.section')
		const $content = $section.querySelector('.content')
		const expanded = $toggle.getAttribute('aria-expanded') === 'true'
		$toggle.setAttribute('aria-expanded', !expanded)
		$section.dataset.expanded = !expanded
		$content.classList[expanded ? 'add' : 'remove']('visibility-hidden')
	})
})

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE HEADER JAVASCRIPT
 * focus main navigation on large
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $dropdownMenuNav = document.querySelector('.dropdown-menu-nav')
const $$mainMenuSections = $dropdownMenuNav.querySelectorAll('.section')
const $$mainMenuTitles = $dropdownMenuNav.querySelectorAll('.title a')
const $$mainMenuUls = $dropdownMenuNav.querySelectorAll('.content')
function mainNavCheckMouseOut(event) {
	const $header = event.target.closest('.header')
	if ($header) {
		const $section = event.target.closest('.dropdown-menu-nav .section')
		_.each($$mainMenuSections, $section => $section.dataset.expanded = 'false')
		_.each($$mainMenuToggles, $toggle => $toggle.setAttribute('aria-expanded', 'false'))
		_.each($$mainMenuUls, $ul => $ul.classList.add('visibility-hidden'))
		if ($section) {
			$section.dataset.expanded = 'true'
			$section.querySelector('.toggle').setAttribute('aria-expanded', 'true')
			$section.querySelector('.content').classList.remove('visibility-hidden')
		}
	}
}
function closeMainMenuSections(event) {
	if (!$dropdownMenuNav.contains(event.target)) {
		_.each($$mainMenuSections, $section => $section.dataset.expanded = 'false')
		_.each($$mainMenuToggles, $toggle => $toggle.setAttribute('aria-expanded', 'false'))
		_.each($$mainMenuUls, $ul => $ul.classList.add('visibility-hidden'))
	}
}
/*function responsiveHeaderSections() {
	const isLargeView = viewportDimensions().width >= _MEDIA_MEDIUM
	if (isLargeView) {
		// using jQuery for convenience here
		$('body').on('focus.dropdown-menu-nav', '*', mainNavCheckMouseOut)
	} else {
		// using jQuery for convenience here
		$('body').off('focus.dropdown-menu-nav', '*', mainNavCheckMouseOut)
	}
	_.each($$mainMenuTitles, $title => {
		const $section = $title.closest('.section')
		const $toggle = $section.querySelector('.toggle')
		const $ul = $section.querySelector('.content')
		if (isLargeView) {
			const haspopup = $toggle.getAttribute('temp-haspopup')
			if (haspopup) {
				$toggle.setAttribute('aria-haspopup', haspopup)
			}
			$toggle.removeAttribute('temp-haspopup')
			$toggle.setAttribute('aria-expanded', 'false')
			$section.dataset.expanded = 'false'
			$ul.classList.remove('visibility-hidden')
			document.addEventListener('click', closeMainMenuSections)
		} else if ($mainMenuDropdown.classList.contains('visibility-hidden')) {
			const haspopup = $toggle.getAttribute('aria-haspopup')
			if (haspopup) {
				$toggle.setAttribute('temp-haspopup', haspopup)
			}
			$section.removeAttribute('aria-haspopup')
			$ul.classList.add('visibility-hidden')
			document.removeEventListener('click', closeMainMenuSections)
		}
	})
}
responsiveHeaderSections()
window.addEventListener('resize', () => responsiveHeaderSections())*/

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Main & Search Navigation
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $menuToggle = document.querySelector('.header .main-menu > button')
const $menuDropdown = document.querySelector('.header .dropdown-menu')
const $searchToggle = document.querySelector('.header .search > button')
const $searchDropdown = document.querySelector('.header .dropdown-search')
function menuItemToggle(menuClass, $toggle, $dropdown) {
	return function() {
		const expanded = $toggle.getAttribute('aria-expanded') === 'true'
		if (expanded) {
			// it is open, so close it
			$html.classList.remove('menu-item-open')
			$html.classList.remove(menuClass)
			$dropdown.setAttribute('aria-hidden', 'true')
			$toggle.setAttribute('aria-expanded', !expanded)
			$dropdown.classList.add('visibility-hidden')
		} else {
			if ($html.classList.contains('menu-item-open')) {
				// resetting everything
				$html.classList.remove('menu-main-open')
				$html.classList.remove('menu-search-open')
				$menuToggle.setAttribute('aria-expanded', 'false')
				$searchToggle.setAttribute('aria-expanded', 'false')
				$menuDropdown.setAttribute('aria-hidden', 'true')
				$searchDropdown.setAttribute('aria-hidden', 'true')
				$menuDropdown.classList.add('visibility-hidden')
				$searchDropdown.classList.add('visibility-hidden')
				// now open the menu
				$html.classList.add(menuClass)
				$dropdown.removeAttribute('aria-hidden')
				$toggle.setAttribute('aria-expanded', !expanded)
				$dropdown.classList.remove('visibility-hidden')
			} else {
				// it is not open elsewhere, so open it
				$html.classList.add('menu-item-open')
				$html.classList.add(menuClass)
				$dropdown.removeAttribute('aria-hidden')
				$toggle.setAttribute('aria-expanded', !expanded)
				$dropdown.classList.remove('visibility-hidden')
			}
			if (menuClass === 'menu-search-open') {
				$dropdown.querySelector('input').focus()
			}
		}
	}
}
$menuToggle.addEventListener('click', menuItemToggle('menu-main-open', $menuToggle, $menuDropdown))
$searchToggle.addEventListener('click', menuItemToggle('menu-search-open', $searchToggle, $searchDropdown))

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Accessibility tab loops for main menu
 * (both forward and backward loops)
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

let isMediumOrSmallerView = viewportDimensions().width < _MEDIA_MEDIUM
window.addEventListener('resize', () => isMediumOrSmallerView = viewportDimensions().width < _MEDIA_MEDIUM)

const $menuFocusFirst = document.querySelector('#menu-focus-first')
const $menuFocusLast = document.querySelector('#menu-focus-last')
$menuFocusLast.addEventListener('keydown', event => {
	if (isMediumOrSmallerView && !event.shiftKey && event.keyCode === 9 && !$menuDropdown.classList.contains('visibility-hidden')) {
		event.preventDefault()
		$menuFocusFirst.focus()
	}
})
$menuFocusFirst.addEventListener('keydown', event => {
	if (isMediumOrSmallerView && event.shiftKey && event.keyCode === 9 && !$menuDropdown.classList.contains('visibility-hidden')) {
		event.preventDefault()
		$menuFocusLast.focus()
	}
})

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Tabs
 *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
const $$tabs = document.querySelectorAll('.tabs button')
_.each($$tabs, $tab => {
	$tab.addEventListener('click', event => {
		const $thisTabBlock = event.target.closest('.tab-block')
        const tabId = event.target.dataset.tabsTarget
        tabsSetAllInactive($thisTabBlock)
        tabsSetActiveTab($thisTabBlock, tabId)
	})
})

function tabsSetAllInactive($tabBlock) {
    const $$tabs = $tabBlock.querySelectorAll('.tabs-title')
	_.each($$tabs, $tab => {
		$tab.classList.remove('is-active')
		$tab.querySelectorAll('button')[0].removeAttribute('aria-selected')
	})

    const $$tabsPanels = $tabBlock.querySelectorAll('.tabs-panel')
    _.each($$tabsPanels, $tabPanel => {
        $tabPanel.classList.remove('is-active')
    })
}

function tabsSetActiveTab($tabBlock, tabId) {
	const $activeTab = $tabBlock.querySelectorAll('[data-tabs-target="' + tabId + '"]')[0]
	$activeTab.setAttribute('aria-selected', true)
    $activeTab.closest('.tabs-title').classList.add('is-active')
    $tabBlock.querySelectorAll('[data-tab="' + tabId + '"]')[0].classList.add('is-active')
}

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * "Resources For" Responsive Dropdown
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $$subUtilityNavs = document.querySelectorAll('.sub-utility')
const $$subUtilityToggles = document.querySelectorAll('.sub-utility .toggle')
function closeUtilityLinks(event) {
	if (!event.target.closest('.sub-utility')) {
		_.each($$subUtilityNavs, $nav => $nav.dataset.expanded = 'false')
		_.each($$subUtilityToggles, $nav => $nav.setAttribute('aria-expanded', 'false'))
	}
}
function responsiveResourcesFor() {
	const isLarge = viewportDimensions().width >= _MEDIA_MEDIUM
	_.each($$subUtilityNavs, $nav => {
		const $toggle = $nav.querySelector('.toggle')
		if (isLarge) {
			const expanded = $toggle.getAttribute('temp-expanded')
			if (expanded) {
				$nav.dataset.expanded = expanded
				$toggle.setAttribute('aria-expanded', expanded)
			}
			$toggle.removeAttribute('temp-expanded')
			document.addEventListener('click', closeUtilityLinks)
		} else {
			const expanded = $toggle.getAttribute('aria-expanded')
			if (expanded) {
				$toggle.setAttribute('temp-expanded', expanded)
			}
			$nav.removeAttribute('data-expanded')
			$toggle.removeAttribute('aria-expanded')
			document.removeEventListener('click', closeUtilityLinks)
		}
	})
}
responsiveResourcesFor()
window.addEventListener('resize', () => responsiveResourcesFor())


_.each($$subUtilityToggles, $toggle => {
	const $nav = $toggle.closest('.sub-utility')
	$toggle.addEventListener('click', function() {
		const expanded = $toggle.getAttribute('aria-expanded') === 'true'
		$nav.dataset.expanded = !expanded
		$toggle.setAttribute('aria-expanded', !expanded)
	})
})

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Sub Navigation
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $subNavToggle = document.querySelector('.nav-sub-bar .main-toggle')
if ($subNavToggle) {
	const $subNavDropdown = document.querySelector('.nav-sub-bar .dropdown')
	$subNavToggle.addEventListener('click', function() {
		const expanded = $subNavToggle.getAttribute('aria-expanded') === 'true'
		if (expanded) {
			$subNavDropdown.setAttribute('aria-hidden', 'true')
			$subNavDropdown.classList.add('visibility-hidden')
		} else {
			$subNavDropdown.removeAttribute('aria-hidden')
			$subNavDropdown.classList.remove('visibility-hidden')
		}
		$subNavToggle.setAttribute('aria-expanded', !expanded)
	})
	const $subNav = document.querySelector('.nav-sub')
	document.addEventListener('click', function(event) {
		if (!$subNav.contains(event.target)) {
			$subNavDropdown.setAttribute('aria-hidden', 'true')
			$subNavToggle.setAttribute('aria-expanded', 'false')
			$subNavDropdown.classList.add('visibility-hidden')
		}
	})
	// toggling on each section
	const $$toggles = document.querySelectorAll('.nav-sub .dropdown [aria-controls]')
	_.each($$toggles, $toggle => {
		$toggle.addEventListener('click', function() {
			const $li = $toggle.closest('li')
			const expanded = $toggle.getAttribute('aria-expanded') === 'true'
			$toggle.setAttribute('aria-expanded', !expanded)
			$li.dataset.expanded = !expanded
		})
	})
}

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * RESPONSIVE FOOTER JAVASCRIPT
 * the use case is here for changing functionality
 * at different responsive dimensions to
 * match CSS responsive dimensions
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

const $$footerGroups = document.querySelectorAll('.footer-nav .group')
function responsiveFooter() {
	const isSmall = viewportDimensions().width < _MEDIA_SMALL
	_.each($$footerGroups, $group => {
		const $toggle = $group.querySelector('.toggle')
		if (isSmall) {
			const expanded = $toggle.getAttribute('temp-expanded')
			if (expanded) {
				$group.dataset.expanded = expanded
				$toggle.setAttribute('aria-expanded', expanded)
			}
			$toggle.removeAttribute('temp-expanded')
		} else {
			const expanded = $toggle.getAttribute('aria-expanded')
			if (expanded) {
				$toggle.setAttribute('temp-expanded', expanded)
			}
			$group.removeAttribute('data-expanded')
			$toggle.removeAttribute('aria-expanded')
		}
	})
}
responsiveFooter()
window.addEventListener('resize', () => responsiveFooter())

// toggling on each section
const $$footerToggles = document.querySelectorAll('.footer-nav .toggle')
_.each($$footerToggles, $toggle => {
	$toggle.addEventListener('click', function() {
		const $group = $toggle.closest('.group')
		const expanded = $toggle.getAttribute('aria-expanded') === 'true'
		$toggle.setAttribute('aria-expanded', !expanded)
		$group.dataset.expanded = !expanded
	})
})

// /** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
//  * Responsive tables NO LONGER USING IN FAVOR OF FOUNDATION
// *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

// $('table.table').basictable({
// 	breakpoint: 700,
// })

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * Jump to top of page button in footer
*** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

document.querySelector('#back-to-top-footer').addEventListener('click', event => {
	event.preventDefault()
	window.scroll(0, 0)
	document.body.focus()
})
